<template>
    <div class="myColumn">
      <div class="my-title">个性测评测试结果</div>
      <dir class="radar-con"><div id="radar" style="width: 600px;height: 400px;"></div></dir>
      <div class="result-show">您的个性测评职业倾向分析结果为:{{recommendJg}}（{{allSpecialty[recommendJg[0]]}} {{resultCount[recommendJg[0]]}} + {{allSpecialty[recommendJg[1]]}} {{resultCount[recommendJg[1]]}} + {{allSpecialty[recommendJg[2]]}} {{resultCount[recommendJg[2]]}}） </div>
      <div class="result-profession">适合职业: {{recommendSubject}}</div>
      <div class="result-major">参考专业: {{recommendProfessional}}</div>
      <div class="result-condition">选课要求：{{resultCondition}}</div>
    </div>
</template>

<script>
//引入底部导航组件
export default {
  name: 'result',
  data() {
    return {
      recommendProfessional: '',
      recommendSubject: '',
      recommendJg: '',
      resultCount: {},
      resultCondition: "首选物理，再选化学+生物",
      allSpecialty:{'A': '艺术型A', 'E': '管理型E', 'C': '常规型C', 'I': '研究型I', 'R': '现实型R', 'S': '社会型S'},
      allIndex: []
    };
  },
  created() {
     console.log(this.$route.query)
     this.recommendProfessional = this.$route.query.recommend.shzy;
     this.recommendSubject = this.$route.query.recommend.dyzy;
     if (this.$route.query.recommend.jg == 'ACR')
        this.resultCondition = "首选历史，再选地理+其他"
     this.recommendJg = this.$route.query.recommend.jg
     this.resultCount = this.$route.query.resultCount;
     this.allIndex = '' + this.recommendSubject.jg;
  },
  methods: {
    drawRadar() {
      //基于准备好的dom，初始化echarts实例
      let myRadar = this.$echarts.init(document.getElementById('radar'));
      //绘制图表
       // 各个维度的最大值
      var dataMax = [
        {
          name: '艺术:A',
          max: 10,
        },
        {
          name: '管理:E',
          max: 10
        },
        {
          name: '常规:C',
          max: 10
        },
        {
          name: '研究:I',
          max: 10
        },
        {
          name: '实际:R',
          max: 10
        },
        {
          name: '社会:S',
          max: 10
        }
      ]

      var option = {
        tooltip: {  //配置详情提示框组件
          //设置雷达图的tooltip不会超出div，也可设置position属性
          //设置定位不会随着鼠标移动而变化
          confine: true,  //设置是否将tooltip框限制在图表的区域内
          enterable: true,  //设置鼠标是否可以移动到tooltip区域内
        },
        radar: {
          indicator: dataMax,  //配置各个维度的最大值
          center: ['45%', '50%'], // 位置
          name: {
            textStyle: {
              color: 'black'
            }
          },
        },
        series: [
          {
            type: 'radar',
            data: [
              {
                name: '考核情况',
                value: [this.resultCount['A'], this.resultCount['E'], this.resultCount['C'], 
                        this.resultCount['I'], this.resultCount['R'], this.resultCount['S']],
                areaStyle: {
                  normal: {
                      color: 'rgba(218, 51, 53, 0.6)' // 选择区域颜色
                  }
                }
              },
            ]
          }
        ]
      }
      myRadar.setOption(option)
      

    }
  },
  mounted() {
    this.drawRadar()
  },

}
</script>

<style>

.myColumn {
  /* margin-top: 60px; */
  margin: 60px auto 0;
  width: 100%;
  height: 720px;
  background: #fff;
  border-radius: 5%;
  /* padding-left: 20%; */
  /* align-items: center; */
}

.my-title{
  color: black;
  font-size: 24px;
  text-align: center;
}

.radar-con {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

#radar {
  width: 50%;
  height: 30em;
  margin-top: 10px;
  color:black
}

.result-show{
   margin-left: 20%;
    margin-right: 135px;
    margin-top: 40px;
    font-size: 22px;
    
}

.result-profession {
  margin-left: 20%;
  margin-right: 135px;
  margin-top: 30px;
  font-size: 22px;
}

.result-major {
  margin-left: 20%;
  margin-right: 65px;
  margin-top: 20px;
  font-size: 22px;
}

.result-condition {
  margin-left: 20%;
  margin-right: 65px;
  margin-top: 20px;
  font-size: 22px;
}
</style>
